import { NoOp } from 'utils/noop';
import { Nullable } from 'utils/tsHelpers';
import { MutateVariantResponse } from './common';
import { VariantFieldValues, VariantFormFieldKey } from './variantCard';
import { DeleteExperimentVariantProps } from './variantConfiguration';

export type CopyAssistFormAttributes = {
  formFieldWrapperRef: React.RefObject<HTMLDivElement>;
  formFieldRef: React.RefObject<HTMLDivElement>;
};

export type CopyAssistFormState = {
  [k in string]: CopyAssistFormAttributes;
};

export type CopyAssistContextState = {
  copyAssistFormState: Nullable<CopyAssistFormState>;
  activatedFormField: Nullable<VariantFormFieldKey>;
  activateCopyAssist: (fieldName: VariantFormFieldKey, key: string) => void;
  closeCopyAssist: NoOp;
};

export interface CreateVariantsFromSuggestionsProps {
  experimentId: number;
  currentVariantId: number;
  currentVariantCount: number;
  suggestions: string[];
  fieldName: VariantFormFieldKey;
  currentLocale: string;
  createExperimentVariant: (
    copyFromTemplateId: number,
    locale: string,
    newNameOpt?: string | undefined,
    updateRedux?: boolean,
  ) => Promise<MutateVariantResponse>;
  deleteExperimentVariant: (
    deleteVariantProps: DeleteExperimentVariantProps,
    locale: string,
    updateRedux: boolean,
  ) => Promise<boolean>;
  updateExperimentVariant: (
    variantId: number,
    variantFieldValues: VariantFieldValues,
    showErrorToaster: boolean,
    updateRedux: boolean,
  ) => Promise<MutateVariantResponse>;
  closeCopyAssistDropdown: () => void;
  refetch: NoOp;
  validateTemplate: (templateId: number) => void;
}

export enum ERROR_CODE {
  ALL_VARIANT_CREATION_FAILED = 'no_changes',
  SOME_VARIANT_CREATION_FAILED = 'revert_creation',
  SOME_VARIANT_UPDATES_FAILED = 'retain_changes_revert_creation',
  ALL_VARIANT_UPDATES_FAILED = 'revert_all_creation',
}
